export const STORE_KEY_ADMIN_COUNTRY = "admin-country";

export const COUNTRY_CODE_INDIA = "in";
export const COUNTRY_CODE_BRAZIL = "br";
export const COUNTRY_CODE_PHILIPPINES = "ph";

export const COUNTRY_OPTIONS = [
    { value: COUNTRY_CODE_INDIA,  label: "印度" },
    { value: COUNTRY_CODE_BRAZIL, label: "巴西" },
    { value: COUNTRY_CODE_PHILIPPINES, label: "菲律宾" },
];

// 国家对应的请求域名（拼接接口路径用）
export const COUNTRY_DOMAIN_API_MAP = {
    // [COUNTRY_CODE_INDIA]:  "https://13.127.231.201:8081/",
    [COUNTRY_CODE_INDIA]:  "https://admin.winlottery.cc/api",
    [COUNTRY_CODE_BRAZIL]: "https://admin.winlottery.cc/api-bra",
    [COUNTRY_CODE_PHILIPPINES]: "https://admin.winlottery.cc/api-ph",
};

export const DEFAULT_COUNTRY = COUNTRY_CODE_INDIA;

function isValidCountryCode(code) {
    return !!COUNTRY_DOMAIN_API_MAP[code];
}

function safeGetWindow() {
    try {
        if (typeof window !== "undefined") return window;
    } catch (e) {}
    return null;
}

export function getCurrentCountry() {
    const w = safeGetWindow();
    let saved = null;
    if (w && w.localStorage) {
        try {
            saved = w.localStorage.getItem(STORE_KEY_ADMIN_COUNTRY);
        } catch (e) {
            saved = null;
        }
    }
    if (saved && isValidCountryCode(saved)) {
        return saved;
    }
    return DEFAULT_COUNTRY;
}

export function setCurrentCountry(code) {
    const finalCode = isValidCountryCode(code) ? code : DEFAULT_COUNTRY;
    const w = safeGetWindow();
    if (w && w.localStorage) {
        try {
            w.localStorage.setItem(STORE_KEY_ADMIN_COUNTRY, finalCode);
        } catch (e) {}
    }
    return finalCode;
}

export function getCountryLabel(code) {
    const opt = COUNTRY_OPTIONS.find((x) => x.value === code);
    return opt ? opt.label : "";
}

export function getCountryDomainApi(code) {
    const c = code || getCurrentCountry();
    return COUNTRY_DOMAIN_API_MAP[c] || COUNTRY_DOMAIN_API_MAP[DEFAULT_COUNTRY];
}

// 兼容旧写法：Config.domainApi
// 这里用 getter 让每次读取都按当前国家计算（配合刷新生效）
export const Config = {
    get domainApi() {
        return getCountryDomainApi(getCurrentCountry());
    },
};
